import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { CredentialService } from "src/app/modules/authentication/credential.service";
import { BrowserStorageService } from "../services/browser-storage.service";
import { authenticationRoutesPath } from "src/app/modules/authentication/authentication.routes";

export const AuthGuard = () => {
  const router = inject(Router);
  const browserStorage = inject(BrowserStorageService);
  const credentialService = inject(CredentialService);
  const token = credentialService.getAccessToken();

  if (!token) {
    browserStorage.clearBrowserStorage(credentialService.getAuthStorage());
    router.navigate([authenticationRoutesPath.LOGIN]);
    return false;
  }
  return true;
};
